//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getNewStocksDetails } from '~/api/index';
export default {
  props: {
    hotspotData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      timer: null,
    };
  },
  mounted() {
    this.updateStocks();
    this.timer = setInterval(() => {
      this.updateStocks();
    }, 3e4);
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  },
  methods: {
    /**
     * @description 跳转路由
     * @param { String } url 跳转路径
     */
    openUrl(url) {
      window.open(url);
    },
    /**
     * @description 更新股票详情
     */
    async updateStocks() {
      if (this.hotspotData.stocks) {
        const arr = this.hotspotData.stocks.map(
          item => `${item.market}${item.code}`
        );
        if (arr.length > 0) {
          const data = await this.$axios(
            getNewStocksDetails({
              stockCodes: arr.join(','),
            })
          );
          if (data.result) {
            data.result.forEach(item => {
              const stockcode = `${item.market.toLowerCase()}${item.code}`;
              const index = arr.indexOf(stockcode);
              if (
                this.hotspotData.stocks[index] &&
                stockcode ===
                  `${this.hotspotData.stocks[index].market.toLowerCase()}${
                    this.hotspotData.stocks[index].code
                  }`
              ) {
                this.hotspotData.stocks[index].price = item.price;
                this.hotspotData.stocks[index].netChange = item.netChange;
                this.hotspotData.stocks[index].negotiateMarketValue =
                  item.negotiateMarketValue;
              }
            });
          }
        }
      }
    },
  },
};
